import React, { ReactElement, ReactNode, isValidElement } from "react";

interface SectionHeaderProps {
  children: ReactNode;
}

const PageHeading: React.FC<SectionHeaderProps> = ({ children }) => {
  // Apply specific styles to known elements and ensure each child has a unique key
  const styledChildren = React.Children.map(children, (child, index) => {
    if (isValidElement(child)) {
      let className = child.props.className || "";

      if (child.type === "h1") {
        className += " text-4xl";
      } else if (child.type === "h2") {
        className += " text-3xl";
      } else if (child.type === "p" || child.type === "span") {
        className += " text-lg text-left text-gray";
      }
      return React.cloneElement(child as ReactElement<any>, {
        key: child.key ?? Math.random() + "" + index, // Ensuring each child has a unique key
        className: className.trim(),
      });
    }
    return child;
  });

  return (
    <div className="flex flex-col max-w-[90%] text-left space-y-2">
      {styledChildren}
    </div>
  );
};

export default PageHeading;
